import { UndergroundStorageTankInput } from "generated-graphql/graphql";

export function transform(input: UndergroundStorageTankInput): UndergroundStorageTankInput {
  return {
    ...input,
  };
}
